export default {
  SCROLL_DEBOUNCE_TIME: 300,
  INFINITE_SCROLL_TRIGGER: 120,
};
